module.exports = __webpack_public_path__ + "static/media/IMG_3365.75ea4705.JPG";